import { FileInfo } from ".";
import { RequestContext } from "../options";
import { BaseApiRequest, baseApiRequestHandler } from "../baseApiRequest";
import { mapUnsanitizedFilesToFiles } from "./utils";

export const uploadFiles = (files: FileList | File[], ctx: RequestContext): BaseApiRequest<FileInfo[]> => {
  const formData = new FormData();

  [...files].forEach((f) => formData.append("files", f));

  const url = `${ctx.apiUrl}/api/files`;

  return baseApiRequestHandler(
    url,
    new Promise<FileInfo[]>((resolve, reject) => {
      const ajax = new XMLHttpRequest();
      ajax.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          const createdFiles: FileInfo[] = JSON.parse(this.responseText);
          resolve(mapUnsanitizedFilesToFiles(createdFiles));
        }
      };
      ajax.onerror = function (e) {
        reject(e);
      };
      ajax.open("POST", url);
      ajax.withCredentials = true;
      ajax.send(formData);
    })
  );
};
